import { Badge, InlineStack } from '@customerio/pluma-components/react';
import { FlexMark } from '@/components/flex-mark';
import * as styles from './segments-addon-button.css';

/**
 * The "Flex add-on" tag inside a menu entry that already opens the add-on. A button can't nest in
 * a menu item, so this is a read-only Badge with the Flex tag's tint.
 */
export function FlexAddonBadge() {
  return (
    <Badge className={styles.flexBadge} color="accent">
      <InlineStack as="span" alignBlock="center" gap="050">
        <FlexMark />
        Flex add-on
      </InlineStack>
    </Badge>
  );
}
